<template>
  <component
    v-if="icon"
    :is="icon"
    class="icon"
    :style="{ width: sizePx, height: sizePx }"
  />
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },

  size: {
    type: [Number, String],
    default: 24,
  },
})

let icon = null

try {
  icon = defineAsyncComponent(() =>
    import(`@/assets/icons/${props.name}.svg`)
  )
} catch {
  console.error(`Icon ${this.name} not found`)
}

const sizePx = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
</script>

<style lang="scss" scoped>
.icon {
  display: inline-block;
}
</style>
